import { createRoot } from "react-dom/client";

// style.scss
import "assets/style.css";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// apex-chart
import "assets/third-party/apex-chart.css";
import "assets/third-party/react-table.css";

import "@fontsource/public-sans/400.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/600.css";
import "@fontsource/public-sans/700.css";

// project imports
import App from "./App";
import { ConfigProvider } from "contexts/ConfigContext";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";

import { SnackbarProvider } from "notistack";

const container = document.getElementById("root");
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
	<Provider store={store}>
		<PersistGate persistor={persistor}>
			<ConfigProvider>
				<SnackbarProvider maxSnack={3} autoHideDuration={4000}>
					<HelmetProvider>
						<App />
					</HelmetProvider>
				</SnackbarProvider>
			</ConfigProvider>
		</PersistGate>
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
